import { render, staticRenderFns } from "./BillOfMaterials.vue?vue&type=template&id=05a67ea0&"
import script from "./BillOfMaterials.vue?vue&type=script&lang=js&"
export * from "./BillOfMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports